
import { getAssetItem } from 'src/utils/helpers';
import {Vue, Component} from 'vue-property-decorator';
import OnboardingSlide from '../OnboardingSlide.vue';

@Component({
  components: {OnboardingSlide},
  methods: {getAssetItem}
  })
export default class LevelSlideResult extends Vue {
  private userWantChrome = false;
}
